const closes = (c) => c.map((x) => x.c);

export function sma(data, n) {
  const out = [];
  let sum = 0;
  data.forEach((d, i) => {
    sum += d.c;
    if (i >= n) sum -= data[i - n].c;
    if (i >= n - 1) out.push({ time: d.t, value: sum / n });
  });
  return out;
}

export function emaArr(vals, n) {
  const k = 2 / (n + 1);
  const out = [];
  let prev = null;
  vals.forEach((v, i) => {
    prev = prev == null ? v : v * k + prev * (1 - k);
    out.push(i >= n - 1 ? prev : null);
  });
  return out;
}

export function ema(data, n) {
  return emaArr(closes(data), n).map((v, i) => (v == null ? null : { time: data[i].t, value: v })).filter(Boolean);
}

export function vwap(data) {
  let pv = 0;
  let vol = 0;
  let day = null;
  return data.map((d) => {
    const dd = Math.floor(d.t / 86400);
    if (dd !== day) { pv = 0; vol = 0; day = dd; }
    const tp = (d.h + d.l + d.c) / 3;
    pv += tp * (d.v || 1);
    vol += d.v || 1;
    return { time: d.t, value: pv / vol };
  });
}

export function bollinger(data, n = 20, k = 2) {
  const up = [];
  const lo = [];
  for (let i = n - 1; i < data.length; i++) {
    const w = data.slice(i - n + 1, i + 1).map((x) => x.c);
    const m = w.reduce((a, b) => a + b, 0) / n;
    const sd = Math.sqrt(w.reduce((a, b) => a + (b - m) ** 2, 0) / n);
    up.push({ time: data[i].t, value: m + k * sd });
    lo.push({ time: data[i].t, value: m - k * sd });
  }
  return { up, lo };
}

export function rsi(data, n = 14) {
  const out = [];
  let g = 0;
  let l = 0;
  for (let i = 1; i < data.length; i++) {
    const ch = data[i].c - data[i - 1].c;
    const gain = Math.max(ch, 0);
    const loss = Math.max(-ch, 0);
    if (i <= n) { g += gain / n; l += loss / n; } else { g = (g * (n - 1) + gain) / n; l = (l * (n - 1) + loss) / n; }
    if (i >= n) out.push({ time: data[i].t, value: l === 0 ? 100 : 100 - 100 / (1 + g / l) });
  }
  return out;
}

export function macd(data) {
  const c = closes(data);
  const e12 = emaArr(c, 12);
  const e26 = emaArr(c, 26);
  const line = c.map((_, i) => (e12[i] != null && e26[i] != null ? e12[i] - e26[i] : null));
  const valid = line.map((v) => v ?? 0);
  const sig = emaArr(valid, 9);
  const res = { macd: [], signal: [], hist: [] };
  line.forEach((v, i) => {
    if (v == null || i < 34) return;
    const t = data[i].t;
    res.macd.push({ time: t, value: v });
    res.signal.push({ time: t, value: sig[i] });
    res.hist.push({ time: t, value: v - sig[i], color: v - sig[i] >= 0 ? "rgba(0,208,156,0.6)" : "rgba(255,77,79,0.6)" });
  });
  return res;
}

export function heikinAshi(data) {
  const out = [];
  data.forEach((d, i) => {
    const c = (d.o + d.h + d.l + d.c) / 4;
    const o = i === 0 ? (d.o + d.c) / 2 : (out[i - 1].o + out[i - 1].c) / 2;
    out.push({ ...d, o, c, h: Math.max(d.h, o, c), l: Math.min(d.l, o, c) });
  });
  return out;
}
